import { defineComponent } from 'vue';
export default defineComponent({
    props: {
        image: {
            type: Object,
            default: null,
        },
        lazy: {
            type: Boolean,
            default: true,
        },
        alt: {
            type: String,
            default: null,
            required: false,
        },
        intristicWidth: {
            type: [Number, String],
            default: null,
        },
        intristicHeight: {
            type: [Number, String],
            default: null,
        },
        // Image width for breakpoints
        hd: {
            type: String,
            default: '2560x0_ratio',
        },
        xxl: {
            type: String,
            default: '1920x0_ratio',
        },
        xl: {
            type: String,
            default: '1440x0_ratio',
        },
        lg: {
            type: String,
            default: '1200x0_ratio',
        },
        md: {
            type: String,
            default: '1200x0_ratio',
        },
        sm: {
            type: String,
            default: '1200x0_ratio',
        },
        xs: {
            type: String,
            default: '1200x0_ratio',
        },
    },
});
